import { render, staticRenderFns } from "./CustomersRegistryNewForm.vue?vue&type=template&id=1384fc77"
import script from "./CustomersRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./CustomersRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports